module.exports = __webpack_public_path__ + "static/s2-objekt1-28ba397576f1dcf6007d7fc409447685.png";